import React from "react";
import { Navigate } from "react-router-dom";

export default function Require2FA({ children }) {
  const tempUserId = localStorage.getItem("superadmin_user_id");
  const authToken = localStorage.getItem("auth_token");

  // If they're already fully authenticated, send them straight to the app
  if (authToken) {
    return <Navigate to="/dashboard" replace />;
  }

  // If we have the temporary ID (from login step), allow 2FA page
  if (tempUserId) {
    return children;
  }

  // Otherwise user shouldn't be on /2fa
  return <Navigate to="/" replace />;
}
